import React from 'react';
import './AboutPage.css';
import paleBlueDot from '../assets/paleBlueDot.jpg'; // Certifique-se de ter essa imagem no caminho indicado

function AboutPage() {
    return (
        <section className="about" id="sobre">
            <div className="container">
                <div className="image-container">
                    <img
                        src={paleBlueDot}
                        alt="Pálido Ponto Azul"
                        className="profile-image"
                    />
                </div>
                <div className="text-container">
                    <h2>Sobre</h2>
                    <p>
                        A BlueDot nasce da paixão por tecnologia e inovação.
                        Nossa missão é desenvolver soluções digitais intuitivas que resolvam problemas reais
                        de maneira simples e eficiente, sempre colocando o usuário no centro de cada decisão.
                    </p>
                    <p>
                        Acreditamos que a colaboração é essencial para alcançar resultados de sucesso.
                        Por isso, ao longo de cada projeto, convidamos nossos clientes a participarem ativamente,
                        compartilhando suas ideias e sugestões, garantindo um produto final que atenda suas necessidades
                        e expectativas.
                    </p>
                    <p>
                        Na BlueDot, combinamos criatividade, conhecimento técnico e compromisso com a qualidade para
                        transformar desafios em oportunidades, entregando aplicações web e mobile feitas sob medida
                        para o seu negócio.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default AboutPage;
